import i18n from '@/i18n/i18n'
import SupplierStatusService from '@/services/admin/SupplierStatusService'
import { errorMessage } from '@/utilities/helpers.js'

import { SUPPLIER_STATUS_ERROR_MESSAGES } from '@/constants/errorMessages'

const { t } = i18n.global

export const allowedFilters = []
export const allowedIncludes = ''
export const allowedSorts = ''
export const allowedAppends = ''

export const namespaced = true

export const state = {
  statuses: []
}

export const mutations = {
  SET_SUPPLIER_STATUSES(state, statuses) {
    state.statuses = statuses.data
  },
  ADD_SUPPLIER_STATUS(state, statuses) {
    state.statuses.unshift(statuses)
  }
}

export const actions = {
  getSupplierStatuses({ commit, dispatch }, supplier) {
    return new Promise((resolve, reject) => {
      SupplierStatusService.getSupplierStatuses(supplier.id)
        .then(response => {
          commit('SET_SUPPLIER_STATUSES', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: SUPPLIER_STATUS_ERROR_MESSAGES.getSupplierStatusesError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  createSupplierStatus({ dispatch, commit, state }, data) {
    return new Promise((resolve, reject) => {
      SupplierStatusService.createSupplierStatus(data.supplierId, data.params)
        .then(response => {
          commit('ADD_SUPPLIER_STATUS', response.data)

          const notification = {
            type: 'success',
            message: t('store.shared.added', {
              element: t('store.admin.supplier_statuses.supplier_status')
            })
          }

          dispatch('notification/add', notification, {
            root: true
          })

          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: SUPPLIER_STATUS_ERROR_MESSAGES.createSupplierStatusError + errorMessage(err)
          }

          dispatch('notification/add', notification, {
            root: true
          })

          reject(err)
        })
    })
  }
}
